<!----
    Author: hjlee
    Description:
        다국어 텍스트 입력 컨트롤
---->
<template>
  <div v-if="isMounted">
    <div v-for="(charst, index) in inputVal" :key="index" class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text locale-name-area">
          {{ $t('locale.nm.' + charst.locale.locale) }}
          <span v-if="charst.locale.locale !== $store.state.locale" class="original-language">
            - {{ getLocaleName(charst.locale.locale) }}
          </span>
        </span>
      </div>
      <input
        v-model="charst.charst"
        v-validate="computedRules"
        :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError(charst.locale.locale), 'is-valid': hasValidationRules(computedRules) && !hasError(charst.locale.locale) && charst.charst}"
        type="text"
        :name="charst.locale.locale"
        :data-vv-as="title + '(' + $t('locale.nm.' + charst.locale.locale) + ')'"
        :readonly="readonly"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="onInput($event)"
        @change="onChange($event)"
      >
      <div v-show="!hasError(charst.locale.locale) && validMessage" :class="{'valid-feedback': true, 'show-valid': !hasError(charst.locale.locale) && validMessage}">
        {{ validMessage }}
      </div>
      <div v-show="hasError(charst.locale.locale)" :class="{'invalid-feedback': true, 'show-invalid': hasError(charst.locale.locale)}">
        {{ errors.first(charst.locale.locale) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalName: {
      type: String,
      default: 'common'
    },
    validMessage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: undefined
    },
    rules: {
      type: [String, Object],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVal: '',
      isMounted: false
    }
  },
  computed: {
    computedRules: function() {
      const rules = this.parseValidationRules(this.rules)
      if (this.required) {
        rules.required = true
      }
      return rules
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    }
  },
  mounted() {
    this.inputVal = this.value

    if (this.inputVal) {
      for (let i = 0; i < this.$store.state.locales.length; i++) {
        const locale = this.$store.state.locales[i]
        let found = false
        for (let j = 0; j < this.inputVal.length; j++) {
          const charst = this.inputVal[j]
          if (charst.locale.locale === locale.value) {
            found = true
            break
          }
        }
        if (!found) {
          this.inputVal.push({ charst: '', locale: { locale: locale.value } })
        }
      }
    } else {
      this.inputVal = []
      for (let i = 0; i < this.$store.state.locales.length; i++) {
        const locale = this.$store.state.locales[i]
        this.inputVal.push({ charst: '', locale: { locale: locale.value } })
      }
    }
    this.$emit('input', this.inputVal)
    this.$emit('change', this.inputVal)
    this.isMounted = true
  },
  methods: {
    hasError(name) {
      return this.errors.has(name)
    },
    onChange(e) {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
    },
    onInput(e) {
      this.$emit('input', this.inputVal)
    },
    getLocaleName(localeValue) {
      for (let i = 0; i < this.$store.state.locales.length; i++) {
        const locale = this.$store.state.locales[i]
        if (locale.value === localeValue) {
          return locale.text
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
.locale-name-area {
  min-width: 120px;
}
.original-language {
  font-size: 0.7rem;
  margin-left: 5px;
  font-weight: bold;
  color: #783498;
}
</style>
